function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:#D7D7D7;}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:#DAAC00;}\n\t.st5{opacity:0.2;fill:#FFFFFF;}\n\t.st6{fill:none;}\n\t.st7{fill:url(#SVGID_4_);}\n\t.st8{fill:url(#SVGID_5_);}\n\t.st9{fill:url(#SVGID_6_);}\n\t.st10{fill:#D86A31;}\n\t.st11{fill:url(#SVGID_7_);}\n\t.st12{fill:url(#SVGID_8_);}\n\t.st13{fill:url(#SVGID_9_);}\n\t.st15{fill:url(#SVGID_10_);}\n\t.st16{fill:url(#SVGID_11_);}\n\t.st17{fill:url(#SVGID_12_);}\n\t.st18{fill:#409255;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1,89.1c1-20.7,1-41.5,0-62.2C0.3,12.5,11.7,0.5,26,0.5h0c14.3,0,25.7,12,25,26.4c-1,20.7-1,41.5,0,62.2H1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M3,89.2c1-20.7,1-41.7,0-62.4C2.7,20.4,4.9,14.4,9.3,9.7C13.7,5.1,19.6,2.5,26,2.5v86.7H3z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M26,2.5V3c-5.2,2-8.9,6.9-9.3,12.7c-0.4,0-0.8-0.1-1.3-0.1c-5.2,0-9.7,2.7-12.3,6.9c0.6-4.8,2.7-9.2,6.1-12.8 C13.7,5.1,19.6,2.5,26,2.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M51,89.1c0.7,14.4-10.7,26.4-25,26.4h0c-14.3,0-25.7-12-25-26.4H51z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M50,90.1c0.1,6.3-2.2,12.3-6.6,16.9c-4.6,4.9-10.8,7.5-17.4,7.5c-6.7,0-12.9-2.7-17.4-7.5 C4.2,102.4,1.9,96.4,2,90.1h0c0.4,5.6,2.6,10.7,6.5,14.9c4.6,4.9,10.8,7.5,17.4,7.5s12.9-2.7,17.4-7.5C47.3,100.8,49.5,95.7,50,90.1 L50,90.1z"
});

function SvgSenseCookie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 116",
    style: {
      enableBackground: "new 0 0 52 116"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1,
    y1: 44.7982,
    x2: 51,
    y2: 44.7982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D3D3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7D7D7"
    }
  })), _ref3, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.3328,
    y1: 45.8374,
    x2: 23.7055,
    y2: 45.8374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D3D3D3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7D7D7",
      stopOpacity: 0
    }
  })), _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenseCookie);
export default __webpack_public_path__ + "static/media/sense-cookie.ffd545e3.svg";
export { ForwardRef as ReactComponent };